import { render, staticRenderFns } from "./10.vue?vue&type=template&id=8ea21fd4&scoped=true&"
import script from "./10.vue?vue&type=script&lang=js&"
export * from "./10.vue?vue&type=script&lang=js&"
import style0 from "./10.vue?vue&type=style&index=0&id=8ea21fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea21fd4",
  null
  
)

export default component.exports